import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import ReportShell, { RC, dateInp, refreshBtn, excelBtn, thStyle } from './ReportShell';

function SaleHSNCReport() {
    const { isAuthenticated, companyId, branchId, permissions, token, username, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        //fetchTableData();
    }, [isAuthenticated, companyId, branchId, permissions, token, logout]);

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const hasReadReportPermission = permissions.includes('Read Reports');

    // Function to format date as dd/mm/yyyy
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero, months are 0-indexed
        const year = today.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [totalcls, setTotalcls] = useState(0);
    useEffect(() => {
        let totalcls = 0;

        data.forEach(item => {
            totalcls += item.amount;

        });
        setTotalcls(totalcls);
    }, [data]);

    const [hsncType, sethsnc] = useState("1");
    const handlesethsncTypeChange = (event) => {
        sethsnc(event.target.value);
    };

    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setData([]);
            setLoading(true);
            try {
                //const response = await fetchData('ReportAPI', `/SaleHSNWiseDetails/${fromDate}/${toDate}/${companyId}/${hsncType}`, token);
                const response = await fetchData('ReportApi', `/SaleHSNWiseDetails/${companyId}/${hsncType}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Sale HSN Wise Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    // const handleExportExcel = () => {
    //     const wb = XLSX.utils.book_new();

    //     let typeLabel;
    //     if (hsncType === "1") {
    //         typeLabel = "B to B";
    //     } else if (hsncType === "2") {
    //         typeLabel = "B to C";
    //     } else {
    //         typeLabel = "All";
    //     }
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     const headerCaption = `${typeLabel}: To : ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By : ${username}`;
    //     const allDataSheet = [];
    //     allDataSheet.push([headerCaption]);  // Add header caption as the first row

    //     // Define column headers
    //     const headerRow = ['Name', 'Contact No', 'Amount'];
    //     allDataSheet.push(headerRow);  // Add header row

    //     // Add data rows
    //     filteredData.forEach((rowData) => {
    //         const dataRow = [
    //             rowData.name,
    //             rowData.Contactno,
    //             parseFloat(rowData.amount.toFixed(2)),  // Format amount to 2 decimal places
    //         ];
    //         allDataSheet.push(dataRow);
    //     });

    //     // Calculate total amount
    //     const totalAmount = filteredData.reduce((sum, rowData) => sum + parseFloat(rowData.amount), 0);

    //     // Convert allDataSheet array to a worksheet
    //     const allDataWs = XLSX.utils.aoa_to_sheet(allDataSheet);

    //     const sheetName = hsncType === "1" ? "B to B" : (hsncType === "2" ? "B to C" : "All");

    //     // Append the sheet to the workbook
    //     XLSX.utils.book_append_sheet(wb, allDataWs, sheetName);

    //     // Write the workbook to a file
    //     XLSX.writeFile(wb, `${sheetName}.xlsx`);

    // };




    const handleExportExcel = async () => {
        if (!data || data.length === 0) {
            alert("No data to export!");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sale HSN Report");

        // Determine type label
        let typeLabel = hsncType === "1" ? "B to B" : hsncType === "2" ? "B to C" : "All (B to B & B to C)";

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const headerCaption = `${typeLabel} | From: ${formatDate(fromDate)} | To: ${formatDate(toDate)} | Generated on: ${formattedDateTime} by ${username}`;

        // ---- Title Row ----
        worksheet.addRow([headerCaption]);
        worksheet.mergeCells("A1:I1");
        const titleCell = worksheet.getCell("A1");
        titleCell.font = { bold: true, size: 13 };
        titleCell.alignment = { horizontal: "center" };
        worksheet.addRow([]); // blank row

        // ---- Header Row ----
        const headerRow = worksheet.addRow([
            "Sl.No",
            "HSN Code",
            "Quantity",
            "GST Rate",
            "Taxable Amount",
            "CGST Amount",
            "SGST Amount",
            "IGST Amount",
            "Total Amount",
        ]);

        // Header styling
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
            cell.alignment = { horizontal: "center" };
        });

        // ---- Data Rows ----
        data.forEach((item, index) => {
            const row = worksheet.addRow([
                index + 1,
                item.HSNCode || "",
                Number(item.Quantity || 0),
                Number(item.GSTRate || 0),
                Number(item.TaxableAmount || 0),
                Number(item.CGSTAmount || 0),
                Number(item.SGSTAmount || 0),
                Number(item.IGSTAmount || 0),
                Number(item.TotalAmount || 0),
            ]);

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
                if (colNumber >= 5 && colNumber <= 9) {
                    cell.alignment = { horizontal: "right" };
                    cell.numFmt = "#,##0.00";
                }
            });
        });

        // ---- Totals ----
        const totalTaxable = data.reduce((sum, row) => sum + Number(row.TaxableAmount || 0), 0);
        const totalCGST = data.reduce((sum, row) => sum + Number(row.CGSTAmount || 0), 0);
        const totalSGST = data.reduce((sum, row) => sum + Number(row.SGSTAmount || 0), 0);
        const totalIGST = data.reduce((sum, row) => sum + Number(row.IGSTAmount || 0), 0);
        const totalAmount = data.reduce((sum, row) => sum + Number(row.TotalAmount || 0), 0);

        const totalRow = worksheet.addRow([
            "Total",
            "",
            "",
            "",
            totalTaxable,
            totalCGST,
            totalSGST,
            totalIGST,
            totalAmount,
        ]);

        totalRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true };
            cell.border = {
                top: { style: "medium" },
                left: { style: "thin" },
                bottom: { style: "medium" },
                right: { style: "thin" },
            };
            if (colNumber >= 5 && colNumber <= 9) {
                cell.alignment = { horizontal: "right" };
                cell.numFmt = "#,##0.00";
            }
            if (colNumber < 5) {
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2CC" } };
            }
        });

        // ---- Column Widths ----
        const widths = [8, 15, 10, 10, 15, 15, 15, 15, 15];
        widths.forEach((width, i) => {
            worksheet.getColumn(i + 1).width = width;
        });

        // ---- Save File ----
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `SaleHSNReport_${typeLabel.replace(/\s/g, "_")}_${formatDate(toDate)}.xlsx`
        );
    };


    const cellStyle = {
        borderBottom: '1px solid black',
        color: 'white',
        fontWeight: 'bolder',
        padding: '7px',
        textAlign: 'left',
        fontSize: '12px',
    };


    return (
        <ReportShell
            title={`SALE HSN WISE — ${hsncType === "1" ? "B to B" : hsncType === "2" ? "B to C" : "All"}`}
            recordCount={data.length}
            filters={<>
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px' }}>From</span>
                <input type="date" value={fromDate} onChange={handleFromDateChange} style={{ ...dateInp, width: '130px' }} />
                <span style={{ fontSize: '10px', color: RC.muted, marginRight: '4px', marginLeft: '8px' }}>To</span>
                <input type="date" value={toDate} onChange={handleToDateChange} style={{ ...dateInp, width: '130px' }} />
                {[['1','B to B','#2563eb'],['2','B to C','#92400e'],['3','All','#374151']].map(([val, label, color]) => (
                    <label key={val} style={{ fontSize: '11px', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                        <input type="radio" name="hsncType" value={val} checked={hsncType === val} onChange={handlesethsncTypeChange} />
                        <span style={{ color }}>{label}</span>
                    </label>
                ))}
            </>}
            actions={<>
                <button onClick={fetchTableData} style={refreshBtn}>Refresh</button>
                <button onClick={handleExportExcel} style={excelBtn}>Excel</button>
            </>}
            loading={loading}
        >
            <TableContainer component={Paper}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            {[['Sl.No','left'],['HSN Code','left'],['Quantity','right'],['GST Rate','right'],['Taxable','right'],['CGST','right'],['SGST','right'],['IGST','right'],['Total','right']].map(([col, align]) => (
                                <TableCell key={col} style={{ ...thStyle, textAlign: align }}>{col}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.length > 0 ? data.map((row, index) => (
                            <TableRow key={row.id || index} sx={{
                                backgroundColor: index % 2 === 0 ? '#fdfdfd' : '#f7fdfc',
                                '&:hover': { backgroundColor: 'rgba(45,212,191,0.06)' },
                            }}>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{index + 1}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px' }}>{row.HSNCode}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.Quantity}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.GSTRate}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.TaxableAmount}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.CGSTAmount}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.SGSTAmount}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.IGSTAmount}</TableCell>
                                <TableCell sx={{ fontSize: '12px', padding: '5px 8px', textAlign: 'right' }}>{row.TotalAmount}</TableCell>
                            </TableRow>
                        )) : (
                            <TableRow><TableCell colSpan={9} sx={{ textAlign: 'center', padding: '24px', color: '#5a7a7a', fontSize: '12px' }}>No data available</TableCell></TableRow>
                        )}
                        {data.length > 0 && (
                            <TableRow sx={{ backgroundColor: '#f0f4f4' }}>
                                <TableCell colSpan={4} sx={{ fontWeight: 700, padding: '5px 8px', fontSize: '12px' }}>Total</TableCell>
                                <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{data.reduce((s, r) => s + Number(r.TaxableAmount || 0), 0).toFixed(2)}</TableCell>
                                <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{data.reduce((s, r) => s + Number(r.CGSTAmount || 0), 0).toFixed(2)}</TableCell>
                                <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{data.reduce((s, r) => s + Number(r.SGSTAmount || 0), 0).toFixed(2)}</TableCell>
                                <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{data.reduce((s, r) => s + Number(r.IGSTAmount || 0), 0).toFixed(2)}</TableCell>
                                <TableCell sx={{ fontWeight: 700, textAlign: 'right', padding: '5px 8px', fontSize: '12px' }}>{data.reduce((s, r) => s + Number(r.TotalAmount || 0), 0).toFixed(2)}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </ReportShell>
    );
}

export default SaleHSNCReport;
